import React from 'react'
import logoSrc from '../assets/logo.png'

const Logo = ({dim}) => {
  return (
    <img src={logoSrc} alt="GEMS Logo" width={dim} height={dim}/>
  )
}

export default Logo